<template>
	<div>
		<a-spin :spinning="loading" tip="Loading...">
			<CountrySelect v-model="country" :getData="search" v-if="mediaType !== 'GOOGLE'"></CountrySelect>
			<div class="chart-box">
				<a-row class="filter" type="flex" justify="space-between">
					<a-col>
						<span>核心指标：</span>
						<a-select
							v-model="exportType"
							style="width: 120px"
							@change="search"
						>
							<a-select-option value="5">花费指数</a-select-option>
							<a-select-option value="2">展示指数</a-select-option>
							<a-select-option value="1">点击指数</a-select-option>
							<a-select-option value="4">CTR</a-select-option>
							<a-select-option value="3">CPC</a-select-option>
							<a-select-option value="6">CPM</a-select-option>
						</a-select>					
						<span style="margin-left: 24px">类别：</span>
						<!-- <a-date-picker v-model="value4" picker="quarter"/> -->
						<a-select
							v-model="params.groupByType"
							style="width: 120px"
							@change="search"
						>
							<a-select-option value="1">品类</a-select-option>
							<a-select-option value="2">子类</a-select-option>
						</a-select>
						<span style="margin-left: 24px">时间范围：</span>
						<TagDateRange style="width: 250px" v-model="dateRange" :getList="getList" tdDisabled></TagDateRange>
					</a-col>
					<!-- <div>
						<a-button v-if="mode === 'table'" class="export-btn" type="primary" @click="exportClick">导出</a-button>
						<a-radio-group v-model="mode">
							<a-radio-button value="bar">柱状图</a-radio-button>
							<a-radio-button value="table">表格</a-radio-button>
						</a-radio-group>
					</div> -->
				</a-row>
				<v-chart ref="barchart" :options="options" autoresize v-if="mode === 'bar'" style="width: 100%"/>
				<a-table
					:columns="columns"
					:row-key="(record, index) => index"
					:data-source="data"
					:pagination="pagination"
					size="small"
					v-else
					@change="handleTableChange"
					style="margin-top: 24px"
				>
          <template slot="number" slot-scope="text">
						<span v-if="exportType === '5'">$</span><span>{{$getThousandths(text)}}</span>
					</template>
				</a-table>
			</div>
		</a-spin>
	</div>
</template>
<script>
import { analysisByCategory, exportMetaDataAnalysis } from '@/api/template'
import mixin from './rankMixin.js'
import moment from 'moment';
import TagDateRange from "@/components/TagDateRange";
import CountrySelect from './countrySelect'
 
const columns = [
	{
		title: '品类',
		dataIndex: 'categoryName',
		width: 250,
		align: 'left',
	},
]
export default {
	name: 'CategoryRank',
	mixins: [mixin],
	data() {
		return {
			params: {
				groupByType: '1'
			},
			exportType: '5',
			data: [],
			mode: 'bar',
			country: 'ALL',
      dateRange: [moment().subtract(30, 'days').format('YYYY-MM-DD'), moment().subtract(1, 'days').format('YYYY-MM-DD')],
		}
	},
	props: ['mediaType'],
	components: {
		CountrySelect,
		TagDateRange
	},
	computed: {
		columns() {
			let obj = {
				title: this.exportTypeMap[this.exportType].name,
				dataIndex: this.exportTypeMap[this.exportType].value,
				width: 250,
				align: 'right',
				scopedSlots: { customRender: 'number' },
			}
			return [...columns, obj]
		}
	},
	methods: {
		getList() {
      this.loading = true
			this.data = []
      analysisByCategory({
        pageSize: this.pagination.pageSize,
        pageNo: this.pagination.current,
				country: this.country === 'ALL'?undefined:this.country,
				exportType: this.exportType,
				startDate: this.dateRange[0],
				endDate: this.dateRange[1],
				orderByType: this.exportType,
				mediaType: this.mediaType,
        ...this.params
      }).then((res) => {
        this.data = res.data || []
        this.pagination.total = this.data.length
				this.options.dataZoom[0].show = this.data.length > 11
				this.options.series[0].data = this.data.map(v => v[this.exportTypeMap[this.exportType].value])
				this.options.xAxis[0].data = this.data.map(v => v.categoryName)
				this.options.yAxis[0].axisLabel.formatter = '{value}' + this.exportTypeMap[this.exportType].unit
      }).finally(() => this.loading = false)
    },
		// 导出
		exportClick() {
			exportMetaDataAnalysis({
        pageSize: this.pagination.pageSize,
        pageNo: this.pagination.current,
				country: this.country === 'ALL'?undefined:this.country,
				exportType: this.exportType,
				orderByType: this.exportType,
				startDate: this.dateRange[0],
				endDate: this.dateRange[1],
        ...this.params
      }).then((res) => {
				this.$message.success('数据导出中，请稍后在【下载中心】查看')
      }).finally(() => this.loading = false)
		}
	},
	mounted() {
		this.getList()
	},
}
</script>
<style lang="less" scoped>
.export-btn {
	margin-right: 24px;
}
</style>